import styled from 'styled-components';
import { rem } from '../../utils/functions.js';
import { typography } from '../../typography/typography.js';

var Root = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledComponents__Root",
  componentId: "sc-1ta5u3j-0"
})(["display:inline;"]);
process.env.NODE_ENV !== "production" ? Root.displayName = 'Root' : void 0;
var Wrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledComponents__Wrapper",
  componentId: "sc-1ta5u3j-1"
})(["display:inline-flex;box-sizing:border-box;"]);
process.env.NODE_ENV !== "production" ? Wrapper.displayName = 'Wrapper' : void 0;
var PlusMinusButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "styledComponents__PlusMinusButton",
  componentId: "sc-1ta5u3j-2"
})(["border-style:solid;border-color:", ";border-width:", ";color:", ";background-color:", ";width:", ";height:", ";padding:0;box-sizing:border-box;cursor:", ";&:hover,&:focus{background-color:", ";}&:active{background-color:", ";color:", ";}"], function (_ref) {
  var error = _ref.error,
      disabled = _ref.disabled,
      theme = _ref.theme;

  if (error) {
    return theme.colorPalette.utilityColors.error;
  }

  if (disabled) {
    return theme.colorPalette.neutralColors.light.shade_dark_3;
  }

  return theme.colorPalette.neutralColors.dark.shade_light_1;
}, function (_ref2) {
  var error = _ref2.error;
  return error ? '3px' : '2px';
}, function (_ref3) {
  var disabled = _ref3.disabled,
      theme = _ref3.theme;
  return disabled ? theme.colorPalette.neutralColors.light.shade_white : theme.colorPalette.neutralColors.dark.shade_light_1;
}, function (_ref4) {
  var disabled = _ref4.disabled,
      theme = _ref4.theme;
  return disabled ? theme.colorPalette.neutralColors.light.shade_dark_3 : theme.colorPalette.neutralColors.light.shade_white;
}, rem(40), rem(40), function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? 'not-allowed' : 'pointer';
}, function (_ref6) {
  var disabled = _ref6.disabled,
      theme = _ref6.theme;
  return disabled ? theme.colorPalette.neutralColors.light.shade_dark_3 : theme.colorPalette.neutralColors.light.shade_dark_1;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_1;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colorPalette.neutralColors.light.shade_white;
});
process.env.NODE_ENV !== "production" ? PlusMinusButton.displayName = 'PlusMinusButton' : void 0;
var ValueIndicator = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__ValueIndicator",
  componentId: "sc-1ta5u3j-3"
})(["font-family:", ";font-size:", ";font-weight:300;text-align:center;padding:0px 20px;display:inline-block;border-style:solid;border-color:", ";border-width:", ";color:", ";background:", ";height:", ";min-width:", ";line-height:", ";box-sizing:border-box;"], typography.fontFamily, typography.fontSizeSmall, function (_ref9) {
  var error = _ref9.error,
      theme = _ref9.theme;
  return error ? theme.colorPalette.utilityColors.error : theme.colorPalette.neutralColors.light.shade_dark_3;
}, function (_ref10) {
  var error = _ref10.error;
  return error ? '3px 0px' : '2px 0px';
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_1;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.colorPalette.neutralColors.light.shade_white;
}, rem(40), rem(94), function (_ref13) {
  var error = _ref13.error;
  return error ? rem(34) : rem(36);
});
process.env.NODE_ENV !== "production" ? ValueIndicator.displayName = 'ValueIndicator' : void 0;

export { PlusMinusButton, Root, ValueIndicator, Wrapper };
